export default function Footer() {
  const partners = [
    { role: "Promotor", name: "Diamond Invest" },
    { role: "Construtor", name: "Os Novos Construtores" },
    { role: "Venda Exclusiva", name: "ERA · RE/MAX Portugal" },
    { role: "Arquitetura", name: "João Letra Paixão, Arq." },
  ];
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-[#F9F9F6]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <img
              src="/brand/anreal-white.svg"
              alt="ANREÁL"
              data-testid="footer-logo"
              className="h-20 lg:h-24 w-auto mb-6"
            />
            <p className="text-[14px] text-[#F9F9F6]/65 leading-relaxed max-w-sm">
              Condomínio privado em Cantanhede. 42 apartamentos T0–T4. Classificação energética A+. Fase de lançamento ativa.
            </p>
            <a
              href="mailto:geral@diamondinvest.pt"
              data-testid="footer-email"
              className="mt-6 inline-block text-[14px] border-b border-[#F9F9F6]/30 hover:border-[#F9F9F6] pb-0.5"
            >
              geral@diamondinvest.pt
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
            {partners.map((p, i) => (
              <div key={p.role} data-testid={`footer-partner-${i}`}>
                <div className="text-[10px] tracking-[0.24em] uppercase text-[#F9F9F6]/45 mb-3">{p.role}</div>
                <div className="font-display text-[15px] lg:text-base text-[#F9F9F6] leading-snug">{p.name}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F9F9F6]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-[0.18em] uppercase text-[#F9F9F6]/45">
          <div>© {new Date().getFullYear()} ANREÁL Residence · Cantanhede</div>
          <div>Os seus dados são tratados de forma confidencial</div>
        </div>
      </div>
    </footer>
  );
}
